module.exports = __webpack_public_path__ + "media/images/adp_logo-1b3d1eec888d5b45f2cfb35c0bfd4703.png";